export default __webpack_public_path__ + "static/Clarendon_Hotel_3-1adf642cf98dbf355bca1e898de917d2.jpg";